/*
 * @Author: limin
 * @Date: 2019-08-26 18:01:59
 * @Last Modified by: limin
 * @Last Modified time: 2019-08-26 18:02:32
 */
const RequestMethods = {
  POST: 'post',
  GET: 'get',
  PUT: 'put',
  DELETE: 'delete'
}
export default RequestMethods
